import styled from 'styled-components';
const percentageSize = 1.3;

export const AcceptarButton = styled.button`
  opacity: ${({ disabled }) => (disabled ? '40%' : '100%')};
  background-color: #666666;
  color: white;
  border-radius: 10px;
  width: ${({ disabled }) => (disabled ? '40%' : '100%')};
  height: 32px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;

  margin-top: 10px;
  border: 1px solid #666666;
`;
export const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 10px 20px 10px;
`;
